module.exports = __webpack_public_path__ + "img/pic6-0.cccbfe5f.png";